var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafetyGoggles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "safety-goggles",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.9999 16.5C35.0349 16.5 36.6666 18.1317 36.6666 20.1667V25.6667C36.6666 27.7017 35.0349 29.3334 32.9999 29.3334H28.9116L26.6383 27.0784C25.2633 25.6667 23.4116 24.9334 21.4499 24.9334C19.4883 24.9334 17.6549 25.6667 16.2616 27.0784L14.0066 29.3334H10.9999C8.96492 29.3334 7.33325 27.7017 7.33325 25.6667V20.1667C7.33325 18.1317 8.96492 16.5 10.9999 16.5H32.9999ZM32.9999 12.8334H10.9999C9.055 12.8334 7.18974 13.606 5.81447 14.9813C4.4392 16.3565 3.66659 18.2218 3.66659 20.1667V20.1667H1.83325V25.6667H3.66659C3.66659 27.6116 4.4392 29.4769 5.81447 30.8522C7.18974 32.2274 9.055 33 10.9999 33H15.5833C15.6566 32.89 15.7483 32.78 18.8649 29.6634C19.5799 28.9484 20.5149 28.6 21.4499 28.6C22.4033 28.6 23.3383 28.9484 24.0533 29.6634L27.3349 33H32.9999C34.9448 33 36.8101 32.2274 38.1854 30.8522C39.5606 29.4769 40.3333 27.6116 40.3333 25.6667H42.1666V20.1667H40.3333C40.3333 18.2218 39.5606 16.3565 38.1854 14.9813C36.8101 13.606 34.9448 12.8334 32.9999 12.8334Z",
    fill: "url(#paint0_linear_1248_572)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1248_572",
    x1: 16.5445,
    y1: 8.55271,
    x2: 41.4203,
    y2: 29.5286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00058B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#187BF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyGoggles);
export default __webpack_public_path__ + "static/media/safety-goggles.43965ef8feb6fbe6f91b07190ed52ca4.svg";
export { ForwardRef as ReactComponent };